import { translateBackend } from '@assets/i18n/config';

import AddBankAccount from '@ovComponents/3-pattern/addBankAccount/addBankAccount';
import BankAccountCard from '@ovComponents/4-module/bankAccountCard/bankAccountCard';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { WorkflowContext } from '@ovComponents/4-module/workflowCompletion/workflowCompletionContext';
import { Box, IconButton, Stack, Typography } from 'hephaestus/web';
import { AddRounded as AddIcon } from 'hephaestus/webIcons';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const ReviewBankAccountInformationVisual = ({
  options,
  userId,
  loading,
  continueFunc,
  bankAccounts,
  refetchBankAccounts,
  onEdit,
  onRemove,
  updateMode = false,
}: {
  options: any;
  userId: string;
  loading: boolean;
  refetchBankAccounts: any;
  continueFunc: any;
  bankAccounts?: any[];
  onEdit: (bankAccountId: string, newName: string) => void;
  onRemove: (bankAccountId: string) => void;
  grid?: boolean;
  updateMode?: boolean;
}) => {
  const { t } = useTranslation(['client', 'accountTypes', 'accountsDetail']);
  const [addBankAccount, setAddBankAccount] = useState(false);
  const { workflowData } = useContext(WorkflowContext);
  const submit = async () => {
    await continueFunc();
  };

  if (!options) return <></>;

  return (
    <WorkflowCompletionForm
      onSubmit={submit}
      showSubmitButton={!updateMode || options.displayUpdateButton}
      submitButtonProps={{
        label: t('continue'),
        disabled: loading,
        dataTestId: 'continue-button',
      }}
    >
      <Typography variant='displayLarge' sx={{ mt: 1 }}>
        {translateBackend(options?.title)}
      </Typography>
      <Typography variant='bodyLarge' sx={{ mb: 3 }}>
        <ReactMarkdown linkTarget='_blank' remarkPlugins={[remarkGfm]}>
          {translateBackend(options?.subtitle)}
        </ReactMarkdown>
      </Typography>

      <Stack spacing={2}>
        {(bankAccounts ?? []).map((bankAccount: any) => (
          <BankAccountCard
            bankAccount={bankAccount}
            options={options}
            onRemove={() => {
              onRemove(bankAccount.id);
            }}
            onEdit={(newName: string) => {
              onEdit(bankAccount.id, newName);
            }}
          />
        ))}
      </Stack>
      <AddBankAccount
        data-testid='add-bank-account'
        handleClose={() => setAddBankAccount(false)}
        open={addBankAccount}
        bankAccounts={bankAccounts ?? []}
        userId={userId ?? workflowData.currentUserId}
        options={options}
        afterCreate={async () => {
          await refetchBankAccounts();
          setAddBankAccount(false);
        }}
      />

      {options.createAnotherBankAccount && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'left',
            mt: 2,
          }}
        >
          <IconButton aria-label='add' onClick={() => setAddBankAccount(true)}>
            <AddIcon data-testid='add-icon' fontSize='inherit' />
          </IconButton>
          <Typography
            sx={{ position: 'relative', top: '12px' }}
            variant='bodySmall'
          >
            {t('client:bankAccount.addAnotherbankAccount')}
          </Typography>
        </Box>
      )}
    </WorkflowCompletionForm>
  );
};

export default ReviewBankAccountInformationVisual;
